var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col order-1 order-lg-2" }, [
    _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col text-center" }, [
        _c("h2", [_vm._v(_vm._s(_vm.course.title))]),
        _vm._v(" "),
        _vm.course.cover_photo
          ? _c("div", { staticClass: "row mt-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 offset-0 col-md-6 offset-md-3 col-lg-4 offset-lg-4",
                },
                [
                  _c("ImageComponent", {
                    attrs: { component: { file: _vm.course.cover_photo } },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-4" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "text", placeholder: _vm.$t("Search") },
        domProps: { value: _vm.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.query = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mt-4" },
      _vm._l(_vm.filteredSections, function (section) {
        return _c(
          "div",
          { key: section.id, staticClass: "col-12 col-md-6 col-lg-4" },
          [
            _c("div", { staticClass: "h4" }, [
              _vm._v("\n        " + _vm._s(section.title) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "list-group" },
              _vm._l(section.lectures, function (lecture) {
                return _c(
                  "li",
                  { key: lecture.id, staticClass: "list-group-item px-0" },
                  [
                    _c("Lecture", {
                      key: lecture.id,
                      attrs: { lecture: lecture },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-5" }, [
      _c(
        "div",
        { staticClass: "col text-center" },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _vm.lastLecture
              ? _c(
                  "button",
                  {
                    key: "1",
                    staticClass: "btn btn-primary",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goBackToLastLecture.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("translate")("Continue lerning")) +
                        "\n        "
                    ),
                  ]
                )
              : _vm.firstLecture
              ? _c(
                  "button",
                  {
                    key: "2",
                    staticClass: "btn btn-primary",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToFirstLecture.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("translate")("start learning")) +
                        "\n        "
                    ),
                  ]
                )
              : _vm.course.type === "bundle"
              ? _c("div", { key: "3", staticClass: "bg-light p-5" }, [
                  _c(
                    "a",
                    { staticClass: "btn btn-primary", attrs: { href: "/" } },
                    [
                      _vm._v(
                        _vm._s(_vm._f("translate")("Go to your product list"))
                      ),
                    ]
                  ),
                ])
              : _vm.hasLoaded
              ? _c("div", { key: "4", staticClass: "bg-light p-5" }, [
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("translate")(
                          "No published lectures in this course yet"
                        )
                      ) + "."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("translate")(
                          "Please contact me if you have any questions"
                        )
                      ) + "."
                    ),
                  ]),
                ])
              : _c("div", { key: "5", staticClass: "mt-5 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "spinner-border",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  ),
                ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }